import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, Image } from 'react-bootstrap'
import Dropzone from 'react-dropzone'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../conexoes/api'
import {
  imagemPerfil,
  revelarPerfilContaUsuario
} from '../../redux/actions/index'
import {
  camera,
  elipseVerde,
  fecharJanela
} from '../../utils/alternanciaIcones'
import decryptJWT from '../../utils/decryptJWT'
import { MascaraCnpj, MascaraCpf } from '../../utils/mascarasCampos.js'
import MensagemErro from '../componentesModais/mensagens/mensagemErro'
import MensagemInformacao from '../componentesModais/mensagens/mensagemInformacao'
import Botao from '../Mantine/Botao'
import Slider from '../Mantine/Slider'
import SpinerVeye from '../spinnerVeye/spinnerVeye.js'
import './perfil.css'

const TAMANHO_IMAGEM_PERFIL = 512

export default function DesativarDemonstracao() {
  const [spinAtivo, setSpinAtivo] = useState(true)

  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [nome, setNome] = useState('')
  const [email, setEmail] = useState('')
  const [empresa, setEmpresa] = useState('')
  const [cpfCnpj, setCpfCnpj] = useState('')
  const [perfil, setPerfil] = useState('')
  const [ultimoAcesso, setUltimoAcesso] = useState()

  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemInformacao, setRevelarMensagemInformacao] =
    useState(false)
  const [imagemParaRecorte, setImagemParaRecorte] = useState(null)
  const [cropPosicao, setCropPosicao] = useState({ x: 0, y: 0 })
  const [cropZoom, setCropZoom] = useState(1)
  const [arrastandoCrop, setArrastandoCrop] = useState(false)
  const [imagemCropHorizontal, setImagemCropHorizontal] = useState(false)

  const despacho = useDispatch()
  const modal = useRef()
  const imagemCropRef = useRef()
  const quadroCropRef = useRef()
  const dragCropRef = useRef()

  let imagem = useSelector((state) => state.manejadorState.imagemPerfil)

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  async function handleCancelar() {
    setSpinAtivo(false)
    despacho(revelarPerfilContaUsuario(false))
  }

  async function handleCarregarDados() {
    let email
    setSpinAtivo(true)
    await api_gateway
      .get('/m1/consultar/usuario?cd_pav_usuario=' + decryptJWT('codigo'))
      .then((resolve) => {
        if (resolve.data.status === 200 && resolve.data.dados.length != 0) {
          email = resolve.data.dados[0].ds_email
          setNome(resolve.data.dados[0].ds_pav_usuario)
          setEmail(resolve.data.dados[0].ds_email)
          setPerfil(resolve.data.dados[0].ds_pav_perfil)
          if (resolve.data.dados[0].bl_imagem != null && imagem === null) {
            imagem = resolve.data.dados[0].bl_imagem
          }
        } else {
          setMensagemErro('Ocorreu um erro ao consultar seus dados')
          handleMensagemErro(false)
          setSpinAtivo(false)
        }
      })
      .catch(function (error) {
        console.error(error)
      })

    await api_gateway
      .get(
        '/m1/consultar/cliente?cd_pav_cliente=' + decryptJWT('codigoCliente')
      )
      .then((resolve) => {
        if (resolve.data.status === 200 && resolve.data.dados.length != 0) {
          if (resolve.data.dados[0].ds_cnpj == '') {
            setCpfCnpj(MascaraCpf(resolve.data.dados[0].ds_cpf))
          }

          if (!resolve.data.dados[0].ds_cpf) {
            setCpfCnpj(MascaraCnpj(resolve.data.dados[0].ds_cnpj))
          }

          setEmpresa(resolve.data.dados[0].ds_pav_cliente)
        } else {
          setMensagemErro('Ocorreu um erro ao consultar seus dados')
          handleMensagemErro(false)
          setSpinAtivo(false)
        }
      })
      .catch(function (error) {
        console.error(error)
      })
    await api_gateway
      .get('/m1/servicos/token/consultar_login?ds_email=' + email)
      .then((resolve) => {
        if (resolve.data.status === 200 && resolve.data.dados.length != 0) {
          setUltimoAcesso(resolve.data.dados.createdAt)
        } else {
          setMensagemErro('Ocorreu um erro ao consultar seus dados')
          setSpinAtivo(false)
          handleMensagemErro(false)
        }
      })
      .catch(function (error) {
        console.error(error)
      })

    setSpinAtivo(false)
  }

  useEffect(() => {
    handleCarregarDados()
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!imagemCropRef.current) return

    imagemCropRef.current.style.transform = `translate(-50%, -50%) translate(${cropPosicao.x}px, ${cropPosicao.y}px) scale(${cropZoom})`
  }, [cropPosicao, cropZoom])

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemInformacao() {
    if (revelarMensagemInformacao === false) {
      setRevelarMensagemInformacao(true)
    } else {
      setRevelarMensagemInformacao(false)
    }
  }

  function handleLerArquivo(files) {
    let reader = new FileReader()
    if (
      files.size <= 1048576 &&
      files.type.split('/')[0] === 'image' &&
      files.type.split('/')[0] !== 'gif' &&
      files.type.split('/')[0] !== 'psd'
    ) {
      reader.readAsDataURL(files)
      reader.onloadend = () => {
        setImagemParaRecorte(reader.result)
        setCropPosicao({ x: 0, y: 0 })
        setCropZoom(1)
      }
    } else {
      handleMensagemInformacao()
    }
  }

  const handleImagemCropCarregada = ({ target }) => {
    setImagemCropHorizontal(target.naturalWidth > target.naturalHeight)
  }

  const limitarCropPosicao = (x, y, zoom = cropZoom) => {
    const quadro = quadroCropRef.current
    const imagemCrop = imagemCropRef.current

    if (!quadro || !imagemCrop) {
      return { x, y }
    }

    const proporcaoImagem = imagemCrop.naturalWidth / imagemCrop.naturalHeight
    const larguraQuadro = quadro.clientWidth
    const alturaQuadro = quadro.clientHeight
    const larguraBase = imagemCropHorizontal
      ? alturaQuadro * proporcaoImagem
      : larguraQuadro
    const alturaBase = imagemCropHorizontal
      ? alturaQuadro
      : larguraQuadro / proporcaoImagem
    const limiteX = Math.max((larguraBase * zoom - larguraQuadro) / 2, 0)
    const limiteY = Math.max((alturaBase * zoom - alturaQuadro) / 2, 0)

    return {
      x: Math.min(Math.max(x, -limiteX), limiteX),
      y: Math.min(Math.max(y, -limiteY), limiteY)
    }
  }

  const handleIniciarArrasteCrop = (event) => {
    event.preventDefault()
    if (event.currentTarget.setPointerCapture) {
      event.currentTarget.setPointerCapture(event.pointerId)
    }
    setArrastandoCrop(true)
    dragCropRef.current = {
      x: event.clientX,
      y: event.clientY,
      cropPosicao
    }
  }

  const handleArrastarCrop = (event) => {
    if (!arrastandoCrop || !dragCropRef.current) return

    const novaPosicao = limitarCropPosicao(
      dragCropRef.current.cropPosicao.x + event.clientX - dragCropRef.current.x,
      dragCropRef.current.cropPosicao.y + event.clientY - dragCropRef.current.y
    )

    setCropPosicao(novaPosicao)
  }

  const handleFinalizarArrasteCrop = (event) => {
    if (
      event?.currentTarget?.hasPointerCapture?.(event.pointerId) &&
      event.currentTarget.releasePointerCapture
    ) {
      event.currentTarget.releasePointerCapture(event.pointerId)
    }
    setArrastandoCrop(false)
    dragCropRef.current = null
  }

  const handleAlterarZoomCrop = (novoZoom) => {
    setCropZoom(novoZoom)
    setCropPosicao((prev) =>
      limitarCropPosicao(prev.x, prev.y, novoZoom)
    )
  }

  const handleCancelarCrop = () => {
    setImagemParaRecorte(null)
    setCropPosicao({ x: 0, y: 0 })
    setCropZoom(1)
    handleFinalizarArrasteCrop()
  }

  const gerarImagemRecortada = () => {
    const quadro = quadroCropRef.current
    const imagemCrop = imagemCropRef.current

    if (!quadro || !imagemCrop) {
      return null
    }

    const quadroRect = quadro.getBoundingClientRect()
    const imagemRect = imagemCrop.getBoundingClientRect()
    const proporcaoX = imagemCrop.naturalWidth / imagemRect.width
    const proporcaoY = imagemCrop.naturalHeight / imagemRect.height
    const origemX = Math.max((quadroRect.left - imagemRect.left) * proporcaoX, 0)
    const origemY = Math.max((quadroRect.top - imagemRect.top) * proporcaoY, 0)
    const larguraOrigem = Math.min(
      quadroRect.width * proporcaoX,
      imagemCrop.naturalWidth - origemX
    )
    const alturaOrigem = Math.min(
      quadroRect.height * proporcaoY,
      imagemCrop.naturalHeight - origemY
    )
    const canvas = document.createElement('canvas')
    canvas.width = TAMANHO_IMAGEM_PERFIL
    canvas.height = TAMANHO_IMAGEM_PERFIL

    const contexto = canvas.getContext('2d')
    contexto.drawImage(
      imagemCrop,
      origemX,
      origemY,
      larguraOrigem,
      alturaOrigem,
      0,
      0,
      TAMANHO_IMAGEM_PERFIL,
      TAMANHO_IMAGEM_PERFIL
    )

    return canvas.toDataURL('image/jpeg', 0.92)
  }

  const handleConfirmarCrop = async () => {
    const imagemRecortada = gerarImagemRecortada()

    if (!imagemRecortada) {
      handleMensagemInformacao()
      return
    }

    setImagemParaRecorte(null)
    await handleAlterar(imagemRecortada)
  }

  async function handleAlterar(novaImagem) {
    setSpinAtivo(true)
    await api_gateway
      .post('/m1/alterar/usuario', {
        dados: {
          bl_imagem: novaImagem
        },
        condicao: {
          cd_pav_usuario: decryptJWT('codigo')
        }
      })
      .then(function () {
        imagem = novaImagem
        despacho(imagemPerfil(novaImagem))
      })
      .catch(function (error) {
        setMensagemErro(error.response.data.info)
        setRevelarMensagemErro(true)
      })
      .finally(() => {
        setSpinAtivo(false)
      })
  }

  return (
    <Form ref={modal}>
      {imagemParaRecorte ? (
        <div className="modal-acao-desativar-demonstracao modal-crop-perfil fundo-cor-6">
          <Form.Row>
            <Col>
              <img
                className="icone-label-janela nao-selecionavel"
                src={elipseVerde()}
                alt="elipse"
              />
              <Form.Label>
                <div className="fonte-cor-1 label-janela">Ajustar imagem</div>
              </Form.Label>
              <Button
                className="botao-fechar-janela"
                variant="danger"
                onClick={handleCancelarCrop}
              >
                <img
                  className="botao-fechar-janela-icone"
                  src={fecharJanela()}
                  alt="fechar-janela"
                />
              </Button>
            </Col>
          </Form.Row>
          <div className="container-crop-perfil">
            <div className="texto-crop-perfil">
              <div className="fonte-cor-1 titulo-crop-perfil">
                Recorte sua foto de perfil
              </div>
              <div className="fonte-cor-2 descricao-crop-perfil">
                Ajuste o enquadramento para ficar igual ao avatar do menu de
                navegação.
              </div>
            </div>
            <div className="card-crop-perfil fundo-cor-5">
              <div
                className="quadro-crop-perfil"
                ref={quadroCropRef}
                onPointerDown={handleIniciarArrasteCrop}
                onPointerMove={handleArrastarCrop}
                onPointerUp={handleFinalizarArrasteCrop}
                onPointerLeave={handleFinalizarArrasteCrop}
              >
                <img
                  ref={imagemCropRef}
                  className={
                    imagemCropHorizontal
                      ? 'imagem-crop-perfil imagem-crop-perfil-horizontal'
                      : 'imagem-crop-perfil imagem-crop-perfil-vertical'
                  }
                  src={imagemParaRecorte}
                  alt="Prévia do recorte"
                  draggable={false}
                  onLoad={handleImagemCropCarregada}
                />
              </div>
              <div className="campo-zoom-crop-perfil">
                <label
                  className="fonte-cor-1 label-zoom-crop-perfil"
                  htmlFor="zoom-imagem-perfil"
                >
                  Zoom
                </label>
                <Slider
                  id="zoom-imagem-perfil"
                  min={1}
                  max={3}
                  step={0.01}
                  value={cropZoom}
                  onChange={handleAlterarZoomCrop}
                  thumbLabel="Zoom da imagem"
                />
              </div>
            </div>
            <div className="botoes-crop-perfil">
              <Botao
                label="Cancelar"
                variant="outline"
                onClick={handleCancelarCrop}
              />
              <Botao label="Confirmar" onClick={handleConfirmarCrop} />
            </div>
          </div>
        </div>
      ) : (
        <div className="modal-acao-desativar-demonstracao fundo-cor-6">
          {spinAtivo && (
            <div className="componente-spinner-overlay">
              <div className="componente-spinner-container">
                <SpinerVeye />
              </div>
            </div>
          )}
          <Form.Row>
            <Col>
              <img
                className="icone-label-janela nao-selecionavel"
                src={elipseVerde()}
                alt="elipse"
              />
              <Form.Label>
                <div className="fonte-cor-1 label-janela">Meu perfil</div>
              </Form.Label>
              <Button
                className="botao-fechar-janela"
                variant="danger"
                onClick={() => handleCancelar()}
              >
                <img
                  className="botao-fechar-janela-icone"
                  src={fecharJanela()}
                  alt="fechar-janela"
                />
              </Button>
            </Col>
          </Form.Row>
          <Form.Row style={{ marginTop: '2em' }}>
            <Col className="container-imagem-perfil">
              <Form.Row>
                {imagem != '' && imagem != null ? (
                  <img
                    className="icone-usuario-perfil"
                    src={imagem}
                    alt="Imagem"
                  />
                ) : (
                  <img
                    className="icone-usuario-perfil"
                    src="https://jazzaero.com.br/wp-content/uploads/2017/05/default-placeholder-profile-icon-avatar-gray-woman-90197997.jpg"
                    alt="perfil"
                  />
                )}
                <Dropzone
                  onDrop={(acceptedFiles) => handleLerArquivo(acceptedFiles[0])}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <Button className="botao-importar-foto">
                          <Image
                            className="icone-botao-importar-foto"
                            src={camera()}
                            alt="Camera (ícone)"
                          />
                        </Button>
                      </div>
                    </section>
                  )}
                </Dropzone>
                <div className="label-dados-perfil-usuario">
                  <Form.Label>
                    {' '}
                    <div className="fonte-cor-1 label-janela-perfil">
                      {nome}
                    </div>{' '}
                  </Form.Label>
                </div>
              </Form.Row>
            </Col>
            <Col>
              <div>
                <div>
                  <Form.Label className="label-dados-perfil-usuario-login">
                    {' '}
                    <div className="fonte-cor-1 label-campo">Login:</div>{' '}
                  </Form.Label>
                  <Form.Label>
                    {' '}
                    <div className="fonte-cor-2 label-campo">{email}</div>{' '}
                  </Form.Label>
                </div>
                <div className="label-dados-perfil-usuario-ultimo-acesso">
                  <Form.Label className="label-dados-perfil-usuario-login">
                    {' '}
                    <div className="fonte-cor-1 label-campo">
                      Perfil e acesso:
                    </div>{' '}
                  </Form.Label>
                  <Form.Label>
                    {' '}
                    <div className="fonte-cor-2 label-campo">{perfil}</div>{' '}
                  </Form.Label>
                </div>
                <div className="label-dados-perfil-usuario-ultimo-acesso">
                  <Form.Label className="label-dados-perfil-usuario-login">
                    {' '}
                    <div className="fonte-cor-1 label-campo">
                      Último acesso:
                    </div>{' '}
                  </Form.Label>
                  <Form.Label>
                    {' '}
                    <div className="fonte-cor-2 label-campo">
                      {ultimoAcesso &&
                        moment(ultimoAcesso).format('DD/MM/YYYY - HH:mm')}
                    </div>{' '}
                  </Form.Label>
                </div>
              </div>
            </Col>
          </Form.Row>
          <div className="drop-dados-conta-divisora campo-select-divisor-cor-3 conta-dados-divisoria-corpo" />
          <Form.Row className="espaco-reativar-linha">
            <Col>
              <div className="container-empresa-cpf">
                <div className="label-dados-perfil-usuario-empresa">
                  <Form.Label className="label-dados-perfil-usuario-login">
                    {' '}
                    <div className="fonte-cor-1 label-campo">Empresa:</div>{' '}
                  </Form.Label>
                  <Form.Label>
                    {' '}
                    <div className="fonte-cor-2 label-campo">{empresa}</div>{' '}
                  </Form.Label>
                </div>
                <div className="label-dados-perfil-usuario-cpf">
                  <Form.Label className="label-dados-perfil-usuario-login">
                    {' '}
                    <div className="fonte-cor-1 label-campo">CNPJ:</div>{' '}
                  </Form.Label>
                  <Form.Label>
                    {' '}
                    <div className="fonte-cor-2 label-campo">{cpfCnpj}</div>{' '}
                  </Form.Label>
                </div>
              </div>
            </Col>
          </Form.Row>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemInformacao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemInformacao
              handleMensagemInformacao={handleMensagemInformacao}
              mensagemTitulo="Aviso"
              mensagemParagrafo1="A imagem selecionada é muito grande ou está em um formato não suportado."
              mensagemParagrafo2="Por favor, selecione uma imagem com tamanho máximo de até 1Mb."
              mensagemBotao="Ok"
            />
          </div>
        </div>
      )}
    </Form>
  )
}
